import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { PAYMENT } from "@/constants/testIds";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fbfcfe]">
      <Navbar />
      <section className="pt-32 pb-20">
        <div
          data-testid={PAYMENT.cancelContainer}
          className="max-w-2xl mx-auto px-6 md:px-12 text-center"
        >
          <div className="w-20 h-20 mx-auto rounded-full bg-[#8ab8e8]/20 flex items-center justify-center">
            <XCircle className="w-10 h-10 text-[#3d6fa8]" />
          </div>
          <h1
            data-testid={PAYMENT.statusMessage}
            className="mt-8 font-heading text-3xl md:text-4xl font-semibold text-[#2a3b5c]"
          >
            Payment cancelled
          </h1>
          <p className="mt-5 text-[#5c6b85]">
            Your slot is still held. You can complete payment whenever you’re
            ready.
          </p>
          <div className="mt-10 flex justify-center gap-4">
            <Button
              data-testid={PAYMENT.retryButton}
              onClick={() => navigate("/book")}
              className="rounded-full px-6 py-6 bg-[#8ab8e8] hover:bg-[#6fa1d6] text-[#2a3b5c]"
            >
              Try again
            </Button>
            <Button
              data-testid={PAYMENT.returnHomeButton}
              onClick={() => navigate("/")}
              variant="ghost"
              className="rounded-full px-6 py-6"
            >
              Back to home
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
